import { createFileRoute } from "@tanstack/react-router";
import TOTPSetup from "@/auth/totp-setup";

export const Route = createFileRoute("/(root)/root-user/totp-setup")({
  component: () => <TOTPSetup isSuperadmin={true} />,
});
